// extracted by mini-css-extract-plugin
export var boxItems = "_6h-1";
export var boxItemsLg = "_6h-2";
export var button = "_6h-7";
export var buttonHoverless = "_6h-9";
export var buttonLg = "_6h-8";
export var filterGroupBox = "_6h-0";
export var icon = "_6h-3";
export var iconSecondary = "_6h-6";
export var iconWrapper = "_6h-4";
export var iconWrapperLg = "_6h-5";
export var truncatedLabel = "_6h-a";